import React from 'react';
import { useDealByIdQuery, usePurchaseRequestDealsQuery } from 'api';
import { ADMIN_ROUTES } from 'constants/routes';
import { ViewIcon } from 'components/common/icons';
import { Col, Row, Table } from 'components';
import DealProgressStatus from './DealProgressStatus';
import { Link, useParams } from 'react-router-dom';
import moment from 'moment';
import { DealStatusType } from 'components/common/StatusBadge/DealStatusBadge';
import { PurchaseRequestStatusBadge } from 'components/common/StatusBadge';
import { PurchaseRequestStatusType } from 'models/PurchaseRequest';

// Define brand item interface
interface BrandItem {
  id: string;
  brand: string;
  lastUpdated: string;
  assignedTo: string;
  status: string;
}

export const DealGeneral: React.FC = () => {
  const { id } = useParams() as { id: string };
  const { data: dealDetails = {}, isLoading } = useDealByIdQuery({ id });
  const { data: { data = [] } = {} } = usePurchaseRequestDealsQuery({ dealId: id });

  const dealStatus = (dealDetails.status as DealStatusType) || 'SOURCING';

  // Define brand table columns
  const columns = [
    {
      title: 'Brand',
      dataIndex: 'brand',
      key: 'brandId',
      render: (brand: { name: string }) => {
        return brand?.name;
      },
      sorter: true,
    },
    {
      title: 'Last Updated Date',
      dataIndex: 'lastModifiedDate',
      key: 'lastModifiedDate',
      render: (date: string) => {
        return moment(date).format('DD.MM.YYYY HH:mm:ss');
      },
      sorter: true,
    },
    {
      title: 'Assigned To',
      dataIndex: 'assignedTo',
      key: 'assignedTo',
      render: (assignedTo: { firstName: string; lastName: string }) => {
        return `${assignedTo?.firstName || ''} ${assignedTo?.lastName || ''}`;
      },
      sorter: true,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status: PurchaseRequestStatusType) => {
        return <PurchaseRequestStatusBadge type={status} />;
      },
    },
    {
      title: '',
      key: 'actions',
      render: (_: unknown, record: BrandItem) => (
        <Link to={`${ADMIN_ROUTES.purchaseRequest.view}/${record.id}/general`} target={'_blank'}>
          <ViewIcon />
        </Link>
      ),
    },
  ];

  return (
    <Row gutter={[0, 24]}>
      {/* Progress Indicator */}
      <Col span={24}>
        <DealProgressStatus status={dealStatus} width={500} circleSize={50} />
      </Col>

      {/* Brand Status Table */}
      <Col className={'margin-t-20'} span={24}>
        <Table columns={columns} dataSource={data} rowKey="id" pagination={false} loading={isLoading} />
      </Col>
    </Row>
  );
};
